
import ButtonExternalLinkComponent from "@/components/Shared/ButtonExternalLink/ButtonExternalLinkComponent";
export default ButtonExternalLinkComponent;
